import { AspectRatioRounded, ListAltRounded, TableRowsOutlined, ViewCarouselRounded, PriceChange } from '@mui/icons-material';
import { Box, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../hooks/useAuth';
import { USER_TYPE } from '../../../../utils/constants';
import { useEffect, useState } from 'react';
import { isMobile } from '../../../../utils/isMobile';
import { useLocation } from 'react-router';
import { getCustomersSellers, listSellersCustomers, listSellersUsers } from '../../../../store/actions/companies';
import { listInventoryCustomers, listParts, listPartsByCustomer, partsCsvUpload, partsPriceUpdate } from '../../../../store/actions/parts';

import styles from './styles';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { enqueueSnackbar } from '../../../../store/actions/snackbar';
import FileUploadDialog from '../../FileUploadDialog';
import PartsPriceUpdateDialog from '../../PartsPriceUpdateDialog';

const partsByCustomerAccessLevels = [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_MARKETPLACE_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN];

const InventoryView = () => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const mobile = isMobile();
  const classes = styles();
  const location = useLocation();
  const [companyInventory, setCompanyInventory] = useState('');
  const { preferences } = useSelector((state) => state.currentUser);
  const { inventoryCustomers } = useSelector((state) => state.parts);

  const [uploadOpen, setUploadOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [uploadPriceOpen, setUploadPriceOpen] = useState(false);

  const handleAspectRatio = useAspectRatio();

  useEffect(() => {
    setCompanyInventory('');
  }, [location.pathname]);

  useEffect(() => {
    if (user?.type === USER_TYPE.SELLER_MARKETPLACE_ADMIN) {
      dispatch(listSellersUsers(user));
      dispatch(listSellersCustomers(user));
    } else if (user?.type === USER_TYPE.CUSTOMER_MANAGER || user?.type === USER_TYPE.CUSTOMER_USER) {
      dispatch(getCustomersSellers(user));
    }
    if (partsByCustomerAccessLevels.includes(user.type)) {
      if (!inventoryCustomers.loading && inventoryCustomers.data.length === 0) {
        dispatch(listInventoryCustomers());
      }
    }
  }, []);

  const handleCompanyInventory = (e) => {
    setCompanyInventory(e.target.value);
    dispatch(listPartsByCustomer(e.target.value._id));
  };

  const handleInventory = (currentViewState) => {
    let newInventoryViewState;
    switch (user.type) {
      case USER_TYPE.PREMIUM_ADMIN:
      case USER_TYPE.PREMIUM_MARKETPLACE_ADMIN:
      case USER_TYPE.PREMIUM_SELECT_ADMIN:
        newInventoryViewState = (currentViewState + 1) % 3;
        break;
      default:
        newInventoryViewState = (currentViewState + 1) % 2;
        break;
    }
    dispatch({
      type: REDUX_ACTIONS.SET_MARKETPLACE_INVENTORY_VIEW,
      payload: { marketPlaceInventoryView: newInventoryViewState },
    });
  };

  const handleOpenUploadModal = () => {
    setUploadOpen(true);
  };

  const handleUploadSuccess = () => {
    setUploadOpen(false);
    setUploadPriceOpen(false);
    dispatch(
      enqueueSnackbar(
        'CSV uploaded successfully',
        'success',
        new Date().getTime() + Math.random()
      )
    );

    if (companyInventory) {
      dispatch(listPartsByCustomer(companyInventory._id));
    } else {
      dispatch(listParts());
    }
  };

  const handleUploadCsv = (selectedFile) => {
    dispatch(partsCsvUpload(selectedFile, companyInventory._id, setIsLoading, handleUploadSuccess));
  };

  const handleUpdatePartsPrice = (selectedFile, custom2) => {
    dispatch(partsPriceUpdate(selectedFile, { Id: companyInventory._id, Custom2: custom2 }, setIsLoading, handleUploadSuccess));
  };

  return (
    <>
    <>
    {user.marketPlaceInventoryView === 2 && (<Grid>
      <Box sx={{ marginLeft: mobile ? 0 : 'auto' }} className={classes.container}>
      <FormControl
      fullWidth
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <InputLabel id={'comapny-input-label'}>Select</InputLabel>
      <Select
        labelId={'companny-select-id'}
        id={'company-id'}
        value={companyInventory}
        onChange={handleCompanyInventory}
        label={'Select'}
        disabled={inventoryCustomers.loading}
        sx={{
          backgroundColor: 'unset',
        }}
      >
       {inventoryCustomers?.data?.sort((a, b) => (a.firstName || a.name).localeCompare(b.firstName || b.name))
         .map((item, idItem) => (
          <MenuItem key={`item_${item}_${idItem}`} value={item}>
            {item?.firstName || item?.name}
          </MenuItem>
         ))}
      </Select>
    </FormControl>
      </Box>
      </Grid>)}
      </>
      {user.marketPlaceInventoryView === 2 && (
         <Box sx={{ ml: '-10px', mr: '10px' }}>
         <InputAdornment position="end">
           <IconButton
             disabled={!companyInventory._id}
             edge="end"
             onClick={() => {
               handleOpenUploadModal();
             }}
           >
             <WidgetsIcon />
           </IconButton>
         </InputAdornment>
        </Box>
      )}
      {user.marketPlaceInventoryView === 2 && (
         <Box sx={{ mr: '10px' }}>
           <IconButton
             disabled={!companyInventory._id}
             edge="end"
             onClick={() => {
               setUploadPriceOpen(true);
             }}
           >
             <PriceChange />
           </IconButton>
        </Box>
      )}
      <Box sx={{ marginRight: '-5px' }}>
        <InputAdornment position="start">
          <IconButton
            edge="end"
            onClick={() => {
              handleInventory(user.marketPlaceInventoryView);
            }}
          >
            {user.marketPlaceInventoryView === 0 && <ListAltRounded/>}
            {user.marketPlaceInventoryView === 1 && <ViewCarouselRounded />}
            {user.marketPlaceInventoryView === 2 && <TableRowsOutlined/>}
          </IconButton>
        </InputAdornment>
      </Box>
      <Box sx={{ marginLeft: 'auto' }}>
        <InputAdornment position="end">
          <IconButton
            edge="end"
            onClick={() => {
              handleAspectRatio(!preferences.aspectChanged);
            }}
          >
            <AspectRatioRounded />
          </IconButton>
        </InputAdornment>
      </Box>
      {uploadOpen && (
          <FileUploadDialog
          open={uploadOpen}
          handleClose={() => {
            setUploadOpen(false);
          }}
          isLoading={isLoading}
          handleUpload={handleUploadCsv}
        />
      )}
      {uploadPriceOpen && (
          <PartsPriceUpdateDialog
          open={uploadPriceOpen}
          handleClose={() => {
            setUploadPriceOpen(false);
          }}
          isLoading={isLoading}
          handleUpload={handleUpdatePartsPrice}
        />
      )}
    </>
  );
};

export default InventoryView;
